/**
 * Created by denis.gusarov on 7/13/2017.
 */
namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Tween = Factive.Core.Tween.Tween;
    import DependenciesContainer = Factive.Core.DependenciesContainer;

    export class DiceRendererClass {
        private container;

        public renderer:THREE.WebGLRenderer;

        private diceValues: Array<{dice: DiceObject, value: number}> = [];

        private diceManager: DiceManagerClass;
        private diceBonusManager: DiceBonusManagerClass;

        private cannonDebugRenderer: any = null;

        private renderableManager: any;
        private last_time: number;
        private running: number;
        private iteration: number;

        constructor(private _assetScale, private _aspectRatio, renderer: THREE.WebGLRenderer, private gl: WebGLRenderingContext) {

            this.renderer = renderer;
            this.init();
        }

        private _checkExtension(name): boolean {
            return !!this.gl.getExtension(name);
        }

        init()
        {

            // let md = this._dc.get("MobileDetect");
            //
            // if(!!md.phone() == false
            //     && !!md.tablet() == false
            //     && !!md.mobile() == false){
            //     // this.renderer.shadowMap.enabled = true;
            //     // this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;//THREE.PCFShadowMap
            // }
            let usePhongMaterial = this._checkExtension("WEBGL_depth_texture") && this._checkExtension("OES_texture_float_linear");

            this.diceManager = new DiceManagerClass(this._assetScale, usePhongMaterial);
            this.diceManager.setWorld(/*this.world, this.scene*/);

            this.renderableManager = this.diceManager;

            this.diceBonusManager = new DiceBonusManagerClass(this._assetScale, usePhongMaterial);
            this.diceBonusManager.setWorld(/*this.world, this.scene*/);

            this.setManager(this.diceManager);

            if(THREE.CannonDebugRenderer){
                //this.cannonDebugRenderer = new THREE.CannonDebugRenderer(this.diceManager.scene, this.diceManager.world);
            }

            this.diceManager.updatePhysics(1/60);
            this.diceBonusManager.updatePhysics(1/60);

            if(this.cannonDebugRenderer){
                this.cannonDebugRenderer.update();
            }
        }


        setManager(renderableManager: any){
            this.renderableManager = renderableManager;
        }

        private step = 0;
        private call1 = () => {
            return false;
        };
        private call2 = () => {
            return false;
        };

        __animate (qwe,call1, call2)
        {
            this._running = true;
            this._canDraw = true;
            this.call1 = call1;
            this.call2 = call2;
        }

        private _running = false;
        private _canDraw = false;

        animate (frame_rate)
        {
            if(!this._running){
                return;
            }
            this.iteration++;
            this.renderableManager.updatePhysics(frame_rate);

            if(this.cannonDebugRenderer){
                this.cannonDebugRenderer.update();
            }

            if (this.step == 0 && !this.call1())
            {
                this.step = 1;
            }
            else if (this.step == 1 && !this.call2())
            {
                this.step = 2;
                this.running = 0;
                this._running = false;
            }

        };

        // render()
        // {
        //     //this.renderer.render( this.renderableManager.scene, this.renderableManager.camera );
        //     //this.sprite_3D.texture.update();
        // }

        render(texture)
        {
            if(!this._canDraw){
                return;
            }
            this.renderer.state.reset();
            this.renderer.render( this.renderableManager.scene, this.renderableManager.camera );
            //this.sprite_3D.texture.update();
        }

        //---

        clear() {
            // this.running = false;
            // var dice;
            // while (dice = this.dices.pop())
            // {
            //     this.scene.remove(dice);
            //     if (dice.body) this.world.remove(dice.body);
            // }
            // if (this.pane) this.scene.remove(this.pane);
            // this.renderer.render(this.scene, this.camera);
            // var box = this;
            // /*setTimeout(function() { */
            // box.renderer.render(box.scene, box.camera); //}, 100);
        }

        startBonusThrow(handleRollComplete: (box_result:Array<DiceResultInterface>) => void, diceRollingBox: Factive.Game.DiceRollingBox) {

            this.setManager(this.diceBonusManager);

            //this.canUpdatePhysics = true;
            //this.canRender = true;
            let diceValues = [];

            this.diceBonusManager.dices[0].show();

            let index = 0;
            for (let i = 0; i < this.diceBonusManager.dices.length; i++) {
                let dice = this.diceBonusManager.dices[i];
                dice.index = index;
                let yRand = Math.random() * 10;
                dice.getObject().position.x = -2 - (i % 3) * 1.5;
                dice.getObject().position.y = 1 + Math.floor(i / 3) * 1.5;
                dice.getObject().position.z = -1 + (i % 3) * 1.5;
                dice.getObject().quaternion.x = (Math.random()*90-45) * Math.PI / 180;
                dice.getObject().quaternion.z = (Math.random()*90-45) * Math.PI / 180;
                dice.updateBodyFromMesh();
                let rand = Math.random() * 5;
                dice.getObject().body.velocity.set(25 + rand, 20 + yRand, 15 + rand);
                dice.getObject().body.angularVelocity.set(30 * Math.random() -10, 30 * Math.random() -10, 30 * Math.random() -10);
                diceValues.push({dice: dice, value: i + 1});
                dice.value = null;

                let l = dice.getObject().material;
                for (let j = 0; j < l.length; j++)
                {
                    let material = l[j];
                    material.color.set(0xffffff);
                }

                index++;
            }

            //this.diceBonusManager.prepareValues(diceValues);

            this.running = (new Date()).getTime();
            this.last_time = 0;
            this.iteration = 0;
            this.step = 0;
            let body;

            this.__animate(this.running, () => {

                    if(this.iteration < 60){
                        return true;
                    }

                    let isFinished = 0;
                    for (let i = 0; i < this.diceBonusManager.dices.length; i++) {
                        let dice = this.diceBonusManager.dices[i];
                        isFinished += dice.isFinished()? 1:0;
                    }

                    if(isFinished == 1){
                        let shape = new CANNON.Box(new CANNON.Vec3(4.7,4.7,2));

                        body = new CANNON.Body({mass: 0, shape: shape, material: this.diceBonusManager.barrierBodyMaterial});
                        body.addShape(shape);
                        this.diceBonusManager.world.addBody(body);
                        body.position.set(0, 0, -1.0);

                        this.iteration = 0;

                        return false;
                    }else{

                        return true;
                    }

                },
                () => {

                    let isFinished = 0;
                    for (let i = 0; i < this.diceBonusManager.dices.length; i++) {
                        let dice = this.diceBonusManager.dices[i];
                        isFinished += dice.isFinished()? 1:0;
                    }
                    if(isFinished != 1) {
                        return true;
                    }

                    this.diceBonusManager.world.remove(body);

                    let result:Array<DiceResultInterface> = [];

                    for (let i = 0; i < diceValues.length; i++)
                    {
                        let obj = <DiceResultInterface>{};
                        let dice = diceValues[i].dice;
                        let realValue = dice.getUpsideValue();
                        obj.user_id = dice.id;
                        obj.value = realValue;
                        obj.position = dice.getObject().position;
                        obj.color = dice.getColorIndex();
                        obj.isBonus = true;
                        result.push(obj);
                    }

                    this.applyAspectRatio(this._aspectRatio);
                    handleRollComplete.call(diceRollingBox, result);

                    return false;
                });

        }

        hideDices() {
            for (let i = 0; i < 5; i++) {
                this.diceManager.dices[i].hide();
            }
        }

        startRegularThrow2() {

            this.setManager(this.diceManager);

            this.diceValues = [];

            for (let i = 0; i < 5; i++) {
                this.diceManager.dices[i].show();
            }

            let index = 0;
            for (let i = 0; i < this.diceManager.dices.length; i++) {
                if(!this.diceManager.dices[i].visible){
                    continue;
                }
                let dice = this.diceManager.dices[i];
                dice.index = index;
                let yRand = Math.random() * 10;
                dice.mixColors();
                dice.getObject().position.x = -2 - (i) * 1.5;
                dice.getObject().position.y = 1 + Math.floor(i / 3) * 1.5;
                dice.getObject().position.z = -1 + (i) * 1.5;
                dice.getObject().quaternion.x = (Math.random()*90-45) * Math.PI / 180;
                dice.getObject().quaternion.z = (Math.random()*90-45) * Math.PI / 180;
                dice.updateBodyFromMesh();
                let rand = Math.random() * 5;
                dice.getObject().body.velocity.set(25 + rand, 20 + yRand, 15 + rand);
                dice.getObject().body.angularVelocity.set(30 * Math.random() -10, 30 * Math.random() -10, 30 * Math.random() -10);

                dice.value = null;
                this.diceValues.push({dice: dice, value: i + 1});

                let l = dice.getObject().material;
                for (let j = 0; j < l.length; j++)
                {
                    let material = l[j];
                    material.color.set(0xffffff);
                }

                index++;
            }

            for (let i = 0; i < this.diceManager.dices.length; i++) {
                let dice = this.diceManager.dices[i];
                if(!dice.visible){
                    dice.index = index;
                    index++;
                }
            }

            this.running = (new Date()).getTime();
            this.last_time = 0;
            this.iteration = 0;
            this.step = 0;

            this.__animate(this.running, () => {

                    if(this.iteration < 60){
                        return true;
                    }

                    let isFinished = 0;
                    for (let i = 0; i < this.diceManager.dices.length; i++) {
                        let dice = this.diceManager.dices[i];
                        isFinished += dice.isFinished()? 1:0;
                    }

                    if(isFinished == 5){

                        this.iteration = 0;

                        return false;
                    }else{

                        return true;
                    }

                },
                () => {
                    if(this.iteration < 60){
                        return true;
                    }
                    return false;
                });
        }


        startRegularThrow(bag: Array<Factive.Game.DiceData>, handleRollComplete: (box_result:Array<DiceResultInterface>) => void, diceRollingBox: Factive.Game.DiceRollingBox) {

            this.setManager(this.diceManager);

            //this.applyAspectRatio(this._aspectRatio);

            var l = 0;
            if (bag != null && bag != undefined)
            {
                l = bag.length;
            }
            var numNewDices = 5 - l;

            if (numNewDices < 1)
            {
                return;
            }

            //var bagList = new List<Factive.Game.DiceData>(bag);

            //this.canUpdatePhysics = true;
            //this.canRender = true;
            this.diceValues = [];

            if(bag.length == 0){
                for (let i = 0; i < 5; i++) {
                    this.diceManager.dices[i].show();
                }
            }

            let index = 0;
            for (let i = 0; i < this.diceManager.dices.length; i++) {
                if(!this.diceManager.dices[i].visible){
                    continue;
                }
                let dice = this.diceManager.dices[i];
                dice.index = index;
                let yRand = Math.random() * 10;
                dice.mixColors();
                dice.getObject().position.x = -2 - (i) * 1.5;
                dice.getObject().position.y = 1 + Math.floor(i / 3) * 1.5;
                dice.getObject().position.z = -1 + (i) * 1.5;
                dice.getObject().quaternion.x = (Math.random()*90-45) * Math.PI / 180;
                dice.getObject().quaternion.z = (Math.random()*90-45) * Math.PI / 180;
                dice.updateBodyFromMesh();
                let rand = Math.random() * 5;
                dice.getObject().body.velocity.set(25 + rand, 20 + yRand, 15 + rand);
                dice.getObject().body.angularVelocity.set(30 * Math.random() -10, 30 * Math.random() -10, 30 * Math.random() -10);


                //if(this.diceManager.dices[i].visible){
                dice.value = null;
                this.diceValues.push({dice: dice, value: i + 1});
                //}

                let l = dice.getObject().material;
                for (let j = 0; j < l.length; j++)
                {
                    let material = l[j];
                    material.color.set(0xffffff);
                }

                index++;
            }

            for (let i = 0; i < this.diceManager.dices.length; i++) {
                let dice = this.diceManager.dices[i];
                if(!dice.visible){
                    dice.index = index;
                    index++;
                }
            }

            //this.diceManager.prepareValues(this.diceValues);

            this.running = (new Date()).getTime();
            this.last_time = 0;
            this.iteration = 0;
            this.step = 0;
            let body;

            this.__animate(this.running, () => {

                if(this.iteration < 60){
                        return true;
                    }

                    let isFinished = 0;
                    for (let i = 0; i < this.diceManager.dices.length; i++) {
                        let dice = this.diceManager.dices[i];
                        isFinished += dice.isFinished()? 1:0;
                    }

                    if(isFinished == 5){
                        let shape = new CANNON.Box(new CANNON.Vec3(4.7,4.7,2));

                        body = new CANNON.Body({mass: 0, shape: shape, material: this.diceManager.barrierBodyMaterial});
                        body.addShape(shape);
                        this.diceManager.world.addBody(body);
                        body.position.set(0, 0, -1.0);

                        this.iteration = 0;

                        return false;
                    }else{

                        return true;
                    }

                },
                () => {

                    let isFinished = 0;
                    for (let i = 0; i < this.diceManager.dices.length; i++) {
                        let dice = this.diceManager.dices[i];
                        isFinished += dice.isFinished()? 1:0;
                    }
                    if(isFinished != 5) {
                        return true;
                    }

                    // this.canUpdatePhysics = false;
                    // this.canRender = false;

                    this.diceManager.world.remove(body);

                    let result:Array<DiceResultInterface> = [];

                    for (let i = 0; i < this.diceValues.length; i++)
                    {
                        let obj:any = {};
                        let dice = this.diceValues[i].dice;
                        obj.user_id = dice.id;
                        obj.value = dice.getUpsideValue();
                        obj.position = dice.getObject().position;
                        obj.color = dice.getColorIndex();

                        result.push(obj);
                    }

                    for (let i = 0; i < this.diceManager.dices.length; i++) {
                        let dice = this.diceManager.dices[i];
                        if (dice.visible) {
                            continue;
                        }
                        let obj:any = {};
                        obj.user_id = dice.id;
                        obj.value = dice.getUpsideValue();
                        obj.position = dice.getObject().position;
                        obj.color = dice.getColorIndex();
                        result.push(obj);
                    }

                    this.applyAspectRatio(this._aspectRatio);
                    handleRollComplete.call(diceRollingBox, result);
                    return false;
                });
        }

        hideDiceByUserId(id: any) {
            if(id == 6){
                this.diceBonusManager.hideDiceByUserId(id);
            }else{
                this.diceManager.hideDiceByUserId(id);
            }
            //this.render();
        }

        colorizeDice(id: any, color: number) {
            if(id == 6) return;
            this.diceManager.colorizeDice(id, color);
            //this.render();
        }

        // updateRender() {
        //     //this.render();
        // }

        showDice(id: number, value: number, color: number) {
            if(id == 6){
                this.diceBonusManager.showDice(id, value, color);
            }else{
                this.diceManager.showDice(id, value, color);
            }
            //this.render();
        }

        getDicePositionById (id)
        {
            if(id == 6){
                return this.diceBonusManager.getDicePositionById(id);
            }else{
                return this.diceManager.getDicePositionById(id);
            }
        }

        destroy() {

        }

        applyAspectRatio(aspectRatio: string) {
            this._aspectRatio = aspectRatio;

            //console.log("aspectRatio",aspectRatio);

            for(let i = 0; i < this.diceManager.dices.length; i++){
                this.diceManager.dices[i].applyAspectRatio(aspectRatio);

                {
                    let dice  = this.diceManager.dices[i];
                    if(this._aspectRatio == "landscape"){
                        dice.object.position.copy(dice.object.body.position);
                    } else if(this._aspectRatio == "portrait") {

                        let speed = 30;
                        let destinationPoint = new THREE.Vector3();
                        destinationPoint.x = 5.5;
                        destinationPoint.y = dice.index * 2.5 - 4.8;
                        destinationPoint.z = -4.1;
                        let distance = dice.object.position.distanceTo(destinationPoint);
                        let duration = (distance / speed) * 1500; // in milliseconds
                        let tweenPosition = new Tween(dice.object.position)
                            .to(destinationPoint, duration)
                            .start();
                        tweenPosition.onComplete(() => {
                        });

                        // dice.object.position.x = 5.5;
                        // dice.object.position.y = dice.index * 2.5 - 4.8;
                        // dice.object.position.z = -4.1;
                    }
                    dice.object.quaternion.copy(dice.object.body.quaternion);
                }
            }

            for(let i = 0; i < this.diceBonusManager.dices.length; i++){
                this.diceBonusManager.dices[i].applyAspectRatio(aspectRatio);
                {
                    let dice  = this.diceBonusManager.dices[i];
                    if(this._aspectRatio == "landscape"){
                        dice.object.position.copy(dice.object.body.position);
                    } else if(this._aspectRatio == "portrait") {

                        let speed = 30;
                        let destinationPoint = new THREE.Vector3();
                        destinationPoint.x = 5.5;
                        destinationPoint.y = dice.index * 2.5 - 4.8;
                        destinationPoint.z = -4.1;
                        let distance = dice.object.position.distanceTo(destinationPoint);
                        let duration = (distance / speed) * 1500; // in milliseconds
                        let tweenPosition = new Tween(dice.object.position)
                            .to(destinationPoint, duration)
                            .start();
                        tweenPosition.onComplete(() => {
                        });

                    }
                    dice.object.quaternion.copy(dice.object.body.quaternion);
                }
            }

            //this.render();
        }

        // set3dSprite(sprite_3D: PIXI.Sprite) {
        //     this.sprite_3D = sprite_3D;
        // }
        //
        // set3dRenderer(renderer: THREE.WebGLRenderer) {
        //     this.renderer = renderer;
        // }

        resize(width: number, height: number) {
            this.renderer.setSize(width, height);
            this.diceManager.resize(width,height);
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Dices/DiceRendererClass.ts